import {styled} from 'common'
import Table from 'components/Display/Table/Table'
import Page from 'components/Page/Page'
import useFormRateLogic from 'logic/Rates/useFormRateLogic'
import useRates from 'logic/Rates/useRates'
import React from 'react'
import {
    useCreateRateMutation,
    useDeleteRateMutation,
    useEditRateMutation,
    useGetRateQuery,
    useGetRatesQuery,
} from 'store/Store'
import tableHeaderActions from 'constants/tableHeaderActions'

const Rates = () => {
    // const {data: accounts} = useGetAccountsQuery()
    // const tooltipErrorMessage = formatRateErrorMessage(accounts?.data)
    return (
        <Page>
            <Table
                itemName="rate"
                paginationType="external"
                allowDelete
                allowEdit
                allowCreate
                allowExpanded
                useEditMutation={useEditRateMutation}
                useGetQuery={useGetRatesQuery}
                useGetByIdQuery={useGetRateQuery}
                useCreateMutation={useCreateRateMutation}
                useDeleteMutation={useDeleteRateMutation}
                useModal={useRates}
                // tooltipErrorMessage={tooltipErrorMessage}
                useFormLogic={useFormRateLogic}
                costumeTableHeaderActions={tableHeaderActions.rates}
            />
            <ErrorContainer></ErrorContainer>
        </Page>
    )
}

export default Rates

const ErrorContainer = styled.div``
